import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Form, Button, Spinner } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import config from "../../config";
import { toast } from "react-toastify";

const Partner = () => {
  useEffect(() => {
    document.title = `Partner With Us | Agile Seekers`;
    document.getElementById("bodywrap").className = "partnermain";
  }, []);

  // Partner form all field
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [messages, setMessages] = useState("");

  const [errors, setErrors] = useState({});
  const [isSubmittingPartner, setIsSubmittingPartner] = useState(false);

  // All Validations
  const validate = () => {
    const newErrors = {};

    if (!firstname) {
      newErrors.firstname = "First Name is required";
    }

    if (!lastname) {
      newErrors.lastname = "Last Name is required";
    }

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }

    if (!phonenumber) {
      newErrors.phonenumber = "Phone Number is required";
    }

    if (!companyname) {
      newErrors.companyname = "Company Name is required";
    }

    if (!messages) {
      newErrors.messages = "Messages is required";
    }

    return newErrors;
  };

  const partner_submit = async () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmittingPartner(true);
      let item = {};
      item.first_name = firstname;
      item.last_name = lastname;
      item.email = email;
      item.phone_number = phonenumber;
      item.message = messages;
      item.company_name = companyname;

      try {

        let response = await fetch(`${config.API_BASE_URL}/partner_with_us`, {
          method: "post",
          body: JSON.stringify(item),
          headers: {
            "Content-Type": "application/json",
          },
        });
        response = await response.json();

        if (response.status === 1) {

          // Zoho Lead API Code Start
          const payload = {
            data: [
              {
                Company: "Agile",
                First_Name: firstname,
                Last_Name: lastname,
                Email: email,
                Phone: phonenumber,
                Lead_Status: "New",
                Lead_Source: "Direct",
                Page_URL: window.location.href
              },
            ],
            trigger: ["approval", "workflow", "blueprint"],
          };

          try {
            const response = await fetch(`${config.API_BASE_URL}/zoho/partner_with_us`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.status === 1) {
              setErrors({});

              // toast.success(result.message);
            } else {
              // toast.error(result.message);
              console.error("Zoho Error:", result);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
          // Zoho Lead API Code End

          setErrors({});
          setFirstname("");
          setLastname("");
          setEmail("");
          setPhonenumber("");
          setCompanyname("");
          setMessages("");

          // Display alert with message
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred.");
      } finally {
        setIsSubmittingPartner(false); // End the loading state
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <>
      <Navbar />

      <section className="contact-banner">
        <Container fluid>
          <Row>
            <Col className="px-0 contimg">
              <h2>PARTNER WITH US!</h2>
              <Image
                src={`${config.BASE_URL}/assets/images/contact.jpg`}
                className="img-fluid"
                alt="contimg"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact-form">
        <Container>
          <Row>
            <Col md={6} className="cf-left">
              <Col>
                <h3>Partner With Us</h3>
                <Form>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="fname">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter First Name"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                      />

                      {/* First name validation */}
                      {errors.firstname && (
                        <div className="text-danger">{errors.firstname}</div>
                      )}
                    </Form.Group>

                    <Form.Group as={Col} controlId="lname">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Last Name"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                      />

                      {/* Last name validation */}
                      {errors.lastname && (
                        <div className="text-danger">{errors.lastname}</div>
                      )}
                    </Form.Group>
                  </Row>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />

                    {/* Email validation */}
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="phone">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Phone Number"
                      value={phonenumber}
                      onChange={(e) => setPhonenumber(e.target.value)}
                    />

                    {/* Phone Number validation */}
                    {errors.phonenumber && (
                      <div className="text-danger">{errors.phonenumber}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="cname">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Company Name"
                      value={companyname}
                      onChange={(e) => setCompanyname(e.target.value)}
                    />

                    {/* Company Name validation */}
                    {errors.companyname && (
                      <div className="text-danger">{errors.companyname}</div>
                    )}
                  </Form.Group>

                  <Row className="mb-3">
                    <Form.Group className="mb-3" controlId="message">
                      <Form.Label>Messages</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Enter Messages"
                        value={messages}
                        onChange={(e) => setMessages(e.target.value)}
                      />

                      {/* Message validation */}
                      {errors.messages && (
                        <div className="text-danger">{errors.messages}</div>
                      )}
                    </Form.Group>
                  </Row>


                  <Button
                    variant="primary"
                    type="button"
                    onClick={partner_submit}
                    disabled={isSubmittingPartner}
                  >
                    {isSubmittingPartner ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="mx-2"
                        />
                        Loading...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </Button>

                </Form>
              </Col>
            </Col>
            <Col md={6} className="pwu-right">
              <Image
                src={`${config.BASE_URL}/assets/images/pwu.jpg`}
                className="img-fluid"
                alt="pwu"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Partner;
